import React from "react";

const links = ["about", "services", "experience", "work", "contact"];

const Nav = () => (
  <nav
    style={{
      position: "sticky",
      top: 0,
      zIndex: 50,
      background: "rgba(255,255,255,.88)",
      backdropFilter: "blur(12px)",
      borderBottom: "1px solid var(--line)",
    }}
  >
    <div className="pagewrap nav-grid">
      <a href="#top" className="mono fw6" style={{ fontSize: 14.5, color: "var(--ink)" }}>
        ~/mohsin-idrees<span style={{ color: "var(--accent)" }}>_</span>
      </a>
      <div className="fx ac gap24 hide-mobile">
        {links.map((l) => (
          <a key={l} href={`#${l}`} className="navlink">
            {l}
          </a>
        ))}
      </div>
      <div className="fx" style={{ justifyContent: "end" }}>
        <a href="#contact" className="btn btn-primary" style={{ padding: "10px 20px", fontSize: 13.5 }}>
          Book a call<span className="arr">→</span>
        </a>
      </div>
    </div>
    <span
      id="navprogress"
      style={{ position: "absolute", left: 0, bottom: -1, height: 2, background: "var(--accent)", width: "0%" }}
    />
  </nav>
);

export default Nav;
